import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../shared/services/storage.service';
import { AdminService } from '../shared/services/admin.service';
import { Admin } from '../shared/models/admin/admin';
import { LoadPageService } from '../shared/services/load-page.service';
import { NavigationMain } from '../shared/models/menu/navigation-main';
import { AuthService } from '../shared/services/auth.service';

declare let jQuery: any;

@Component({
    selector: 'app-full-layout',
    templateUrl: './full-layout.component.html',
    styleUrls: ['./full-layout.component.css']
})
export class FullLayoutComponent implements OnInit, AfterViewInit {

    admin: Admin;

    title: string;
    year: number;

    components: NavigationMain[] = [];

    constructor(private storageService: StorageService,
        public router: Router, private adminService: AdminService,
        private route: ActivatedRoute,
        private loadPageService: LoadPageService,
        private authService: AuthService) {

        this.admin = this.adminService.loggedAdmin;

        if (!this.admin) {
            this.admin = new Admin();
        }

    }

    ngOnInit() {

        this.components = [
            ...(this.admin.privilege_id === 9
                ? [
                    {
                        name: 'Dossier chef d\'équipe',
                        icon: 'icon-stats-bars2',
                        childrens: [
                            {
                                name: 'Eric',
                                url: '/stats/eric',
                            },
                            {
                                name: 'Yvan',
                                url: '/stats/yvan',
                            },
                            {
        name: 'Expert comptable',
        url: '/stats/expert',
    },
    {
        name: 'Juvenal',
        url: '/stats/juvenal',
    }
                        ]
                    },
                    {
                        name: 'Gestion admins',
                        icon: 'icon-select2',
                        url: '/admins/list-admins',

                    },
                   

                ]
                : []),
            {
                name: 'Gestion clients',
                icon: 'icon-user-tie',
                url: '/admins/list-clients',

            },
             {
            name: 'Paiements',
            icon: 'fa fa-credit-card',
            childrens: [
                {
                    name: 'Envoyer un lien',
                    url: '/send-payment',
                },
                {
                    name: 'Historique des liens',
                    url: '/payment-requests',
                }
            ]
        },

            {
                name: 'Emailing',
                icon: 'icon-envelop',
                url: '/manage-mail/list',

            },
            {
                name: 'Banquier',
                icon: 'fa fa-bank',
                // hidden: !this.adminService.checkIfAdminHasRole(1),
                childrens: [
                    {
                        name: 'Configuration et saisie',
                        url: 'list-bankers'
                    },
                    {
                        name: 'Voir la liste des RDV',
                        url: 'appointments'
                    }
                ]
            },
            ...(this.admin.privilege_id === 9
                ? [
                    {
                        name: 'Collaborateurs',
                        icon: 'icon-users',
                        url: '/collaborateurs',
                    }
                ]
                : []),
            ...(this.admin.privilege_id === 9
                ? [
                    {
                        name: 'Secteurs d\'activité',
                        icon: 'icon-briefcase',
                        url: '/secteurs-activite',
                    }
                ]
                : []),


        ];

        this.changeActiveUrl(this.router.url);


        this.loadPageService.initBeforeLoad();
        const d = new Date();
        this.year = d.getFullYear();
    }

    ngAfterViewInit(): void {
        this.loadPageService.initAfterLoad();
    }

    changeActiveUrl(url: string) {
        this.components.forEach(
            component => {
                component.active = '';
                if (url === component.url) {
                    component.active = 'active';
                    this.title = component.title;
                }
                if (component.childrens) {
                    component.childrens.forEach(
                        child => {
                            child.active = '';
                            if (url.indexOf(child.url) !== -1) {
                                child.active = 'active';
                            }
                        }
                    );
                }
            }
        );
    }

    goUrl(url: string) {
        if (url) {
            this.router.navigate([url]);
            this.changeActiveUrl(url);
        }
    }

    logout() {
        this.authService.logout().subscribe(
            (data) => {
            },
            error => {
            }
        );
        this.storageService.removeAll();
        this.router.navigateByUrl('/auth/login');
    }

}



